import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { Components } from '../../../components';
import { NgClass } from '@angular/common';
import { RdsButtonModule, RdsBadgeModule } from '@rds/angular-components';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokDirective } from '../../../directives/storyblok.directive';

@Component({
  selector: 'inexp-centered-hero',
  imports: [
    StoryblokDirective,
    DynamicModule,
    RdsButtonModule,
    RdsBadgeModule,
    NgClass,
  ],
  templateUrl: './centered-hero.component.html',
  styleUrl: './centered-hero.component.scss',
})
export class CenteredHeroComponent {
  router = inject(Router);
  _editable = input<string>();
  _uid = input<string>();
  component = input<string>();
  components = Components;

  background = input<string>();
  buttons = input<any[]>([]);
  badges = input<any[]>();
  licenceCost = input<string>();
  licenceCostLabel = input<string>();
  applicationTypeLabel = input<string>();
  applicationTypeIcon = input<string>();
  applicationType = input<string>();
  subtitle = input<string>();
  title = input<string>();
  paragraph = input<string>();

}
